/* Aquara — interacciones propias (prefijo mt-) */
(function () {
  if (window.__mtInit) return;
  window.__mtInit = true;

  var reducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observador = null;

  function marcar(el) {
    if (el.dataset.mtInit) return false;
    el.dataset.mtInit = '1';
    return true;
  }

  /* Reveals al hacer scroll (un solo observer compartido) */
  function initReveals(raiz) {
    var els = (raiz || document).querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!('IntersectionObserver' in window) || reducido) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    if (!observador) {
      observador = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('mt-visible');
            observador.unobserve(e.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observador.observe(el); });
  }

  /* Héroe: zoom-out de entrada */
  function initHero(raiz) {
    (raiz || document).querySelectorAll('.mt-hero').forEach(function (hero) {
      if (!marcar(hero)) return;
      var img = hero.querySelector('.mt-hero__media img');
      var listo = function () { requestAnimationFrame(function () { hero.classList.add('mt-listo'); }); };
      if (!img || img.complete) listo();
      else { img.addEventListener('load', listo); img.addEventListener('error', listo); setTimeout(listo, 1500); }
    });
  }

  /* Hotspots: puntos y lista sincronizados */
  function initHotspots(raiz) {
    (raiz || document).querySelectorAll('.mt-hs').forEach(function (hs) {
      if (!marcar(hs)) return;
      var puntos = hs.querySelectorAll('[data-mt-punto]');
      var activar = function (i) {
        puntos.forEach(function (p) { p.classList.toggle('mt-activo', p.getAttribute('data-mt-punto') === String(i)); });
      };
      puntos.forEach(function (p) {
        var i = p.getAttribute('data-mt-punto');
        p.addEventListener('mouseenter', function () { activar(i); });
        p.addEventListener('focus', function () { activar(i); });
        p.addEventListener('click', function () { activar(i); });
      });
      activar(1);
    });
  }

  /* FAQ */
  function initFaq(raiz) {
    (raiz || document).querySelectorAll('.mt-faq__item').forEach(function (item) {
      if (!marcar(item)) return;
      var boton = item.querySelector('.mt-faq__pregunta');
      if (!boton) return;
      boton.addEventListener('click', function () {
        var abierto = item.classList.toggle('mt-abierto');
        boton.setAttribute('aria-expanded', abierto ? 'true' : 'false');
      });
    });
  }

  /* Parallax suave del cierre */
  var parallaxEls = [];
  function initParallax(raiz) {
    if (reducido) return;
    (raiz || document).querySelectorAll('[data-mt-parallax]').forEach(function (el) {
      if (!marcar(el)) return;
      parallaxEls.push(el);
    });
  }
  var pendiente = false;
  function moverParallax() {
    pendiente = false;
    var alto = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < 0 || r.top > alto) return;
      var progreso = (r.top + r.height / 2 - alto / 2) / alto;
      var intensidad = parseFloat(el.getAttribute('data-mt-parallax')) || 40;
      el.style.setProperty('--mt-parallax', (-progreso * intensidad - intensidad / 2).toFixed(1) + 'px');
    });
  }
  window.addEventListener('scroll', function () {
    if (!pendiente && parallaxEls.length) { pendiente = true; requestAnimationFrame(moverParallax); }
  }, { passive: true });

  /* Página de producto: galería, variantes y cantidad */
  function formatoDinero(centimos, formato) {
    var valor = (centimos / 100).toFixed(2);
    var coma = valor.replace('.', ',');
    var miles = valor.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (formato || '${{amount}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, coma)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(centimos / 100))
      .replace(/\{\{\s*amount\s*\}\}/, miles);
  }

  function initProducto(raiz) {
    (raiz || document).querySelectorAll('.mt-pp').forEach(function (pp) {
      if (!marcar(pp)) return;
      var principal = pp.querySelector('.mt-pp__principal img');
      var minis = pp.querySelectorAll('.mt-pp__mini');
      var activarMini = function (mini) {
        if (!mini || !principal) return;
        minis.forEach(function (m) { m.style.borderColor = 'transparent'; m.setAttribute('aria-current', 'false'); });
        mini.style.borderColor = 'var(--mt-profundo)';
        mini.setAttribute('aria-current', 'true');
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = mini.getAttribute('data-mt-grande');
          principal.srcset = '';
          principal.alt = mini.getAttribute('data-mt-alt') || '';
          principal.style.opacity = '1';
        }, 180);
      };
      minis.forEach(function (m) { m.addEventListener('click', function () { activarMini(m); }); });
      var packsDatos = pp.querySelector('[data-mt-packs-datos]');

      var datos = pp.querySelector('[data-mt-variantes]');
      var variantes = [];
      try { variantes = datos ? JSON.parse(datos.textContent) : []; } catch (e) { variantes = []; }
      var formato = pp.getAttribute('data-mt-formato');
      var inputId = pp.querySelector('input[name="id"]');
      var precio = pp.querySelector('.mt-pp__precio-actual');
      var antes = pp.querySelector('.mt-pp__precio-antes');
      var boton = pp.querySelector('.mt-pp__boton');
      var aviso = pp.querySelector('.mt-pp__aviso');
      var textoBoton = boton ? boton.getAttribute('data-mt-texto') : '';
      var textoAgotado = boton ? boton.getAttribute('data-mt-agotado') : '';

      var cambiando = false;
      var actualizar = function () {
        var elegidas = [];
        pp.querySelectorAll('.mt-pp__opcion').forEach(function (grupo) {
          var i = parseInt(grupo.getAttribute('data-mt-opcion'), 10);
          var marcado = grupo.querySelector('input:checked');
          var valor = marcado ? marcado.value : null;
          var etiqueta = grupo.querySelector('.mt-pp__elegido');
          if (etiqueta && valor) etiqueta.textContent = valor;
          if (grupo.hasAttribute('data-mt-parte')) {
            elegidas[i] = elegidas[i] ? (grupo.getAttribute('data-mt-parte') === '0' ? valor + ' · ' + elegidas[i] : elegidas[i] + ' · ' + valor) : valor;
          } else {
            elegidas[i] = valor;
          }
        });
        var v = variantes.find(function (x) {
          return x.options.every(function (o, i) { return o === elegidas[i]; });
        });
        /* Selectores divididos (Color · Pack): marca los packs que no existen para el color elegido
           y, si la combinación no existe, salta al primer pack disponible de ese color */
        pp.querySelectorAll('.mt-pp__opcion[data-mt-parte="1"]').forEach(function (g2) {
          var i = g2.getAttribute('data-mt-opcion');
          var g1 = pp.querySelector('.mt-pp__opcion[data-mt-opcion="' + i + '"][data-mt-parte="0"] input:checked');
          if (!g1) return;
          var primera = null;
          g2.querySelectorAll('input').forEach(function (inp) {
            var existe = variantes.some(function (x) { return x.options[i] === g1.value + ' · ' + inp.value; });
            inp.disabled = !existe;
            inp.parentNode.querySelector('label[for="' + inp.id + '"]').classList.toggle('mt-no-existe', !existe);
            if (existe && !primera) primera = inp;
          });
          if (!v && primera && !cambiando) {
            primera.checked = true; cambiando = true; actualizar(); cambiando = false; v = 'hecho';
          }
        });
        if (v === 'hecho') return;
        if (!v) {
          if (boton) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; }
          return;
        }
        if (inputId) inputId.value = v.id;
        if (precio) precio.textContent = formatoDinero(v.price, formato);
        var hayAhorro = v.compare_at_price && v.compare_at_price > v.price;
        if (antes) {
          if (hayAhorro) { antes.textContent = formatoDinero(v.compare_at_price, formato); antes.hidden = false; }
          else antes.hidden = true;
        }
        var ahorro = pp.querySelector('.mt-pp__ahorro');
        if (ahorro) {
          ahorro.hidden = !hayAhorro;
          if (hayAhorro) ahorro.textContent = ahorro.getAttribute('data-mt-ahorro-texto') + ' ' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
        }
        if (boton) {
          boton.disabled = !v.available;
          boton.querySelector('span').textContent = v.available ? textoBoton : textoAgotado;
        }
        if (v.featured_image_index !== null && v.featured_image_index !== undefined) {
          var mini = pp.querySelector('.mt-pp__mini[data-mt-indice="' + v.featured_image_index + '"]');
          if (mini) activarMini(mini);
          else if (v.imagen && principal) {
            minis.forEach(function (m) { m.style.borderColor = 'transparent'; m.setAttribute('aria-current', 'false'); });
            principal.style.opacity = '0';
            setTimeout(function () { principal.src = v.imagen; principal.srcset = ''; principal.style.opacity = '1'; }, 180);
          }
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      };
      if (packsDatos) {
        initPacks(pp, packsDatos, activarMini, minis, principal);
      } else {
        pp.querySelectorAll('.mt-pp__opcion input').forEach(function (inp) { inp.addEventListener('change', actualizar); });
        if (pp.querySelector('.mt-pp__opcion[data-mt-parte]')) actualizar();
      }
      initBarra(pp);

      var cantidad = pp.querySelector('.mt-pp__cantidad input');
      pp.querySelectorAll('[data-mt-cantidad]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(cantidad.value, 10) || 1;
          n += parseInt(b.getAttribute('data-mt-cantidad'), 10);
          cantidad.value = Math.max(1, n);
        });
      });

      /* Añadir al carrito con el cajón de Dawn si existe; si no, envío normal del formulario.
         El pack Signature añade dos líneas (pack de 5 filtros + recambios) y siempre va por fetch. */
      pp.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
        if (!window.fetch) return;
        var boton = form.querySelector('[name="add"]');
        form.addEventListener('submit', function (ev) {
          var cajon = document.querySelector('cart-drawer');
          var conCajon = cajon && typeof cajon.renderContents === 'function';
          var firma = form.getAttribute('data-mt-firma') === '1' && form.getAttribute('data-mt-recambio');
          if (!conCajon && !firma) return;
          ev.preventDefault();
          if (boton) boton.setAttribute('aria-busy', 'true');
          var raizRutas = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
          var cuerpo, cabeceras = { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' };
          var secciones = conCajon ? cajon.getSectionsToRender().map(function (s) { return s.id; }) : [];
          if (firma) {
            var idPack = form.querySelector('input[name="id"]').value;
            cuerpo = JSON.stringify({
              items: [
                { id: parseInt(idPack, 10), quantity: 1 },
                { id: parseInt(firma, 10), quantity: parseInt(form.getAttribute('data-mt-firma-extra'), 10) || 3 }
              ],
              sections: secciones,
              sections_url: window.location.pathname
            });
            cabeceras['Content-Type'] = 'application/json';
          } else {
            cuerpo = new FormData(form);
            cuerpo.append('sections', secciones.join(','));
            cuerpo.append('sections_url', window.location.pathname);
          }
          fetch(raizRutas + 'cart/add.js', { method: 'POST', headers: cabeceras, body: cuerpo })
            .then(function (r) { return r.json(); })
            .then(function (res) {
              if (res.status) { if (aviso) aviso.textContent = res.description || res.message || ''; return; }
              if (aviso) aviso.textContent = '';
              if (!conCajon) { window.location.href = raizRutas + 'cart'; return; }
              cajon.classList.remove('is-empty');
              cajon.renderContents(res);
            })
            .catch(function () { if (firma) { window.location.href = raizRutas + 'cart'; } else { form.submit(); } })
            .finally(function () { if (boton) boton.removeAttribute('aria-busy'); });
        });
      });
    });
  }

  /* Selector de modelo + pack (tarjetas Essential / Ritual / Signature) */
  function initPacks(pp, nodo, activarMini, minis, principal) {
    var lista = [];
    try { lista = JSON.parse(nodo.textContent); } catch (e) { return; }
    var caja = pp.querySelector('[data-mt-packs]');
    var form = caja ? caja.closest('form') : null;
    if (!caja || !form) return;
    var formato = pp.getAttribute('data-mt-formato');
    var dinero = function (c) { return formatoDinero(Math.round(c), formato); };
    var inputId = form.querySelector('input[name="id"]');
    var stepper = form.querySelector('.mt-pp__cantidad');
    var stepperInput = stepper ? stepper.querySelector('input') : null;
    var comprar = form.querySelector('.mt-pp__comprar');
    var precio = pp.querySelector('.mt-pp__precio-actual');
    var antes = pp.querySelector('.mt-pp__precio-antes');
    var ahorroPrincipal = pp.querySelector('.mt-pp__ahorro');
    var diaPrincipal = pp.querySelector('[data-mt-dia-principal]');
    var boton = form.querySelector('.mt-pp__boton');
    var textoBoton = boton ? boton.getAttribute('data-mt-texto') : '';
    var textoAgotado = boton ? boton.getAttribute('data-mt-agotado') : '';
    var nombreModelo = pp.querySelector('[data-mt-modelo-nombre]');
    var nombrePack = pp.querySelector('[data-mt-pack-nombre]');
    var dias = parseInt(caja.getAttribute('data-mt-dias'), 10) || 60;
    var diaTexto = caja.getAttribute('data-mt-dia-texto') || '';
    var ahorroTexto = caja.getAttribute('data-mt-ahorro-pack') || '';
    var recambioRef = null, firmaExtraRef = 3;
    var firmaPct = parseFloat(caja.getAttribute('data-mt-firma-pct')) || 0;
    /* Pack 3: el pack de 5 con su descuento (redondeado hacia abajo, como Shopify) + los recambios, en la moneda del cliente */
    var precioFirma = function (set) {
      if (!set || !recambioRef) return 0;
      return set.precio - Math.floor(set.precio * firmaPct / 100 + 1e-7) + firmaExtraRef * recambioRef.precio;
    };
    var firmaExtra = parseInt(caja.getAttribute('data-mt-firma-extra'), 10) || 3;
    var recambio = lista.filter(function (x) { return x.pack === 'r'; })[0] || null;
    recambioRef = recambio; firmaExtraRef = firmaExtra;
    var tarjetas = caja.querySelectorAll('[data-mt-pack]');
    var buscar = function (modelo, pack) {
      return lista.filter(function (x) { return x.modelo === modelo && x.pack === pack; })[0] || null;
    };
    if (recambio) {
      form.setAttribute('data-mt-recambio', recambio.id);
      form.setAttribute('data-mt-firma-extra', firmaExtra);
    }

    var mostrarImagen = function (v) {
      if (!v || v.media === null || v.media === undefined) return;
      var mini = pp.querySelector('.mt-pp__mini[data-mt-indice="' + v.media + '"]');
      if (mini) { activarMini(mini); return; }
      if (v.imagen && principal) {
        minis.forEach(function (m) { m.style.borderColor = 'transparent'; m.setAttribute('aria-current', 'false'); });
        principal.style.opacity = '0';
        setTimeout(function () { principal.src = v.imagen; principal.srcset = ''; principal.style.opacity = '1'; }, 180);
      }
    };

    var actualizar = function (origen) {
      var mInput = pp.querySelector('[data-mt-modelos] input:checked');
      var modelo = mInput ? mInput.value : null;
      if (!modelo) {
        var primero = pp.querySelector('[data-mt-modelos] input');
        if (primero) { primero.checked = true; modelo = primero.value; }
      }
      var uno = buscar(modelo, '1') || lista.filter(function (x) { return x.pack === '1'; })[0] || null;

      tarjetas.forEach(function (t) {
        var k = t.getAttribute('data-mt-pack');
        var base = buscar(modelo, k === 's' ? '5' : k);
        var ok = !!base && (k !== 's' || !!recambio);
        var inp = t.querySelector('input');
        inp.disabled = !ok;
        t.classList.toggle('mt-pack--no', !ok);
        var no = t.querySelector('[data-mt-pack-no]');
        if (no) no.hidden = ok;
        var total = k === 's' ? precioFirma(base) : (base ? base.precio : 0);
        var filtros = parseInt(t.getAttribute('data-mt-filtros'), 10) || 1;
        var elPrecio = t.querySelector('[data-mt-pack-precio]');
        if (elPrecio) { elPrecio.textContent = ok ? dinero(total) : ''; }
        var elAhorro = t.querySelector('[data-mt-pack-ahorro]');
        var separado = (uno && recambio) ? uno.precio + (filtros - 1) * recambio.precio : 0;
        var ahorro = separado - total;
        if (elAhorro) {
          var verAhorro = ok && k !== '1' && ahorroTexto && ahorro >= 100;
          elAhorro.hidden = !verAhorro;
          if (verAhorro) elAhorro.textContent = ahorroTexto.replace('[cantidad]', dinero(ahorro));
        }
        var elDia = t.querySelector('[data-mt-pack-dia]');
        if (elDia) {
          var verDia = ok && diaTexto && k !== '1';
          elDia.hidden = !verDia;
          if (verDia) elDia.textContent = diaTexto.replace('[cantidad]', dinero(total / (filtros * dias)));
        }
      });

      var sel = caja.querySelector('input:checked');
      if (!sel || sel.disabled) {
        var libre = caja.querySelector('input:not(:disabled)');
        if (libre) { libre.checked = true; sel = libre; }
      }
      tarjetas.forEach(function (t) { t.classList.toggle('mt-pack--activo', !!sel && t.querySelector('input') === sel); });
      var pack = sel ? sel.value : '1';
      var tarjeta = sel ? sel.closest('[data-mt-pack]') : null;
      var v = buscar(modelo, pack === 's' ? '5' : pack);

      if (nombreModelo) nombreModelo.textContent = modelo || '';
      if (nombrePack) nombrePack.textContent = tarjeta ? tarjeta.getAttribute('data-mt-nombre') : '';

      if (!v) {
        if (boton) { boton.disabled = true; boton.querySelector('span').textContent = textoAgotado; }
        return;
      }
      var esFirma = pack === 's';
      var total = esFirma ? precioFirma(v) : v.precio;
      inputId.value = v.id;
      form.setAttribute('data-mt-firma', esFirma ? '1' : '');
      if (precio) precio.textContent = dinero(total);
      if (antes) antes.hidden = true;
      if (ahorroPrincipal) ahorroPrincipal.hidden = true;
      var filtrosSel = tarjeta ? (parseInt(tarjeta.getAttribute('data-mt-filtros'), 10) || 1) : 1;
      if (diaPrincipal) {
        var verDiaP = diaTexto && pack !== '1';
        diaPrincipal.hidden = !verDiaP;
        if (verDiaP) diaPrincipal.textContent = diaTexto.replace('[cantidad]', dinero(total / (filtrosSel * dias)));
      }
      if (stepper) {
        stepper.hidden = esFirma;
        if (esFirma && stepperInput) stepperInput.value = 1;
        if (comprar) comprar.classList.toggle('mt-pp__comprar--solo', esFirma);
      }
      var disponible = v.disponible && (!esFirma || (recambio && recambio.disponible));
      if (boton) {
        boton.disabled = !disponible;
        boton.querySelector('span').textContent = disponible ? textoBoton : textoAgotado;
      }
      if (origen !== 'inicio') {
        mostrarImagen(v);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      pp.dispatchEvent(new CustomEvent('mt:compra', { bubbles: true, detail: {
        modelo: modelo, pack: pack, packNombre: tarjeta ? tarjeta.getAttribute('data-mt-nombre') : '',
        precio: dinero(total), mini: v.mini, disponible: disponible
      } }));
    };

    pp.querySelectorAll('[data-mt-modelos] input').forEach(function (i) { i.addEventListener('change', function () { actualizar('modelo'); }); });
    caja.querySelectorAll('input').forEach(function (i) { i.addEventListener('change', function () { actualizar('pack'); }); });
    actualizar('inicio');
  }

  /* Barra de compra fija: aparece cuando el botón principal queda por encima de la pantalla */
  function initBarra(pp) {
    var barra = pp.querySelector('[data-mt-barra]');
    var compra = pp.querySelector('.mt-pp__comprar');
    var boton = pp.querySelector('.mt-pp__boton');
    if (!barra || !compra || !boton || !('IntersectionObserver' in window)) return;
    var bBoton = barra.querySelector('[data-mt-barra-boton]');
    var bDetalle = barra.querySelector('[data-mt-barra-detalle]');
    var bPrecio = barra.querySelector('[data-mt-barra-precio]');
    var bImg = barra.querySelector('[data-mt-barra-img]');
    var sincronizar = function () {
      if (bBoton) bBoton.disabled = boton.disabled;
      var p = pp.querySelector('.mt-pp__precio-actual');
      if (bPrecio && p) bPrecio.textContent = p.textContent;
    };
    pp.addEventListener('mt:compra', function (e) {
      var d = e.detail || {};
      if (bDetalle) bDetalle.textContent = [d.modelo, d.packNombre].filter(Boolean).join(' · ');
      if (bImg && d.mini) bImg.src = d.mini;
      sincronizar();
    });
    sincronizar();
    var ver = function (on) {
      barra.classList.toggle('mt-barra--on', on);
      barra.setAttribute('aria-hidden', on ? 'false' : 'true');
      if (bBoton) bBoton.tabIndex = on ? 0 : -1;
      document.documentElement.classList.toggle('mt-con-barra', on);
    };
    new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) { ver(!e.isIntersecting && e.boundingClientRect.top < 0); });
    }).observe(compra);
    if (bBoton) bBoton.addEventListener('click', function () { sincronizar(); if (!boton.disabled) boton.click(); });
  }

  /* Contadores hasta una fecha real (data-mt-fin). Al llegar la fecha, se ocultan. */
  function leerFecha(txt) {
    if (!txt) return null;
    var t = String(txt).trim().replace(' ', 'T');
    var d = new Date(t);
    return isNaN(d.getTime()) ? null : d;
  }
  function dosCifras(n) { return (n < 10 ? '0' : '') + n; }
  var relojes = [];
  function initContadores(raiz) {
    (raiz || document).querySelectorAll('[data-mt-fin]').forEach(function (el) {
      if (!marcar(el)) return;
      var fin = leerFecha(el.getAttribute('data-mt-fin'));
      if (!fin) return;
      relojes.push({ el: el, fin: fin });
    });
    tic();
  }
  function tic() {
    var ahora = Date.now();
    relojes.forEach(function (r) {
      var resta = r.fin.getTime() - ahora;
      var destino = r.el.hasAttribute('data-mt-ocultar-al-fin') ? r.el : (r.el.closest('[data-mt-ocultar-al-fin]') || r.el);
      if (resta <= 0) { destino.hidden = true; return; }
      destino.hidden = false;
      var s = Math.floor(resta / 1000), d = Math.floor(s / 86400), h = Math.floor(s % 86400 / 3600), m = Math.floor(s % 3600 / 60), seg = s % 60;
      var txt = (d > 0 ? d + 'd ' : '') + dosCifras(h) + ':' + dosCifras(m) + ':' + dosCifras(seg);
      var salida = r.el.querySelector('[data-mt-reloj]');
      if (salida) salida.textContent = txt;
    });
  }
  setInterval(function () { if (relojes.length) tic(); }, 1000);

  /* Fechas estimadas de entrega en días hábiles */
  function sumarHabiles(fecha, dias) {
    var f = new Date(fecha.getTime());
    while (dias > 0) { f.setDate(f.getDate() + 1); var dd = f.getDay(); if (dd !== 0 && dd !== 6) dias--; }
    return f;
  }
  function initEntrega(raiz) {
    (raiz || document).querySelectorAll('[data-mt-entrega]').forEach(function (el) {
      if (!marcar(el)) return;
      var hueco = el.querySelector('[data-mt-fechas]');
      if (!hueco) return;
      var hoy = new Date();
      var a = sumarHabiles(hoy, parseInt(el.getAttribute('data-mt-min'), 10) || 7);
      var b = sumarHabiles(hoy, parseInt(el.getAttribute('data-mt-max'), 10) || 15);
      var idioma = document.documentElement.lang || 'en';
      var fmt = function (x) { return x.toLocaleDateString(idioma, { month: 'short', day: 'numeric' }); };
      hueco.textContent = fmt(a) + ' – ' + fmt(b) + '.';
    });
  }

  /* Ventana de bienvenida con la oferta (una vez por visitante, hasta que cierre o acepte) */
  function initPopup(raiz) {
    (raiz || document).querySelectorAll('.mt-popup').forEach(function (pop) {
      if (!marcar(pop)) return;
      var enEditor = window.Shopify && Shopify.designMode;
      var clave = 'mt-popup-' + (pop.getAttribute('data-mt-clave') || '1');
      var visto = false;
      try { visto = localStorage.getItem(clave) === '1'; } catch (e) {}
      var fin = leerFecha(pop.getAttribute('data-mt-popup-fin'));
      if (fin && fin.getTime() <= Date.now()) return;
      if (visto && !enEditor) return;
      var cerrar = function () {
        pop.classList.remove('mt-popup--abierto');
        document.documentElement.classList.remove('mt-popup-activo');
        try { localStorage.setItem(clave, '1'); } catch (e) {}
        setTimeout(function () { pop.hidden = true; }, 400);
        document.removeEventListener('keydown', teclas);
      };
      var teclas = function (e) { if (e.key === 'Escape') cerrar(); };
      pop.querySelectorAll('[data-mt-cerrar]').forEach(function (b) { b.addEventListener('click', cerrar); });
      var abrir = function () {
        pop.hidden = false;
        requestAnimationFrame(function () {
          pop.classList.add('mt-popup--abierto');
          document.documentElement.classList.add('mt-popup-activo');
          var foco = pop.querySelector('.mt-boton');
          if (foco) foco.focus({ preventScroll: true });
        });
        document.addEventListener('keydown', teclas);
      };
      setTimeout(abrir, enEditor ? 0 : (parseInt(pop.getAttribute('data-mt-retraso'), 10) || 3) * 1000);
    });
  }

  /* «In the box»: pestañas por pack, calculadora por dureza del agua y sincronía con la ficha */
  function initCaja(raiz) {
    (raiz || document).querySelectorAll('[data-mt-caja]').forEach(function (caja) {
      if (!marcar(caja)) return;
      var formato = caja.getAttribute('data-mt-formato');
      var diaTexto = caja.getAttribute('data-mt-dia-texto') || '';
      var mesesTexto = caja.getAttribute('data-mt-meses-texto') || '';
      var tabs = caja.querySelectorAll('[data-mt-caja-tab]');
      var paneles = caja.querySelectorAll('[data-mt-caja-panel]');
      var calcular = function (panel) {
        var salida = panel.querySelector('[data-mt-caja-resultado]');
        var marcado = panel.querySelector('.mt-caja__agua input:checked');
        if (!salida || !marcado) return;
        var total = parseInt(panel.getAttribute('data-mt-total'), 10) || 0;
        var filtros = parseInt(panel.getAttribute('data-mt-filtros'), 10) || 1;
        var meses = parseInt(marcado.value, 10) || 2;
        var totalMeses = filtros * meses;
        var porDia = total / (totalMeses * 30);
        salida.textContent = '';
        if (total > 0 && diaTexto) {
          var fuerte = document.createElement('strong');
          fuerte.textContent = diaTexto.replace('[cantidad]', formatoDinero(Math.round(porDia), formato));
          salida.appendChild(fuerte);
        }
        if (mesesTexto) salida.appendChild(document.createTextNode(' ' + mesesTexto.replace('[meses]', totalMeses)));
      };
      var abrir = function (pack, foco) {
        var hay = false;
        tabs.forEach(function (t) { if (t.getAttribute('data-mt-caja-tab') === pack) hay = true; });
        if (!hay) return;
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-mt-caja-tab') === pack;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          if (on && foco) t.focus();
        });
        paneles.forEach(function (p) { p.hidden = p.getAttribute('data-mt-caja-panel') !== pack; if (!p.hidden) calcular(p); });
      };
      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { abrir(t.getAttribute('data-mt-caja-tab')); });
        t.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var sig = tabs[(i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          abrir(sig.getAttribute('data-mt-caja-tab'), true);
        });
      });
      paneles.forEach(function (p) {
        p.querySelectorAll('.mt-caja__agua input').forEach(function (i) {
          i.addEventListener('change', function () {
            /* La misma dureza de agua en todos los packs */
            paneles.forEach(function (otro) {
              var gemelo = otro.querySelector('.mt-caja__agua input[value="' + i.value + '"]');
              if (gemelo) gemelo.checked = true;
              calcular(otro);
            });
          });
        });
        calcular(p);
      });
      var inicial = tabs[0] ? tabs[0].getAttribute('data-mt-caja-tab') : null;
      tabs.forEach(function (t) { if (t.getAttribute('data-mt-caja-tab') === '5') inicial = '5'; });
      if (inicial) abrir(inicial);
      document.addEventListener('mt:compra', function (e) { if (e.detail && e.detail.pack) abrir(e.detail.pack); });
    });
  }

  function initTodo(ev) {
    var raiz = ev && ev.target && ev.target.nodeType === 1 ? ev.target : document;
    document.documentElement.classList.remove('mt-sin-js');
    initReveals(raiz);
    initHero(raiz);
    initHotspots(raiz);
    initFaq(raiz);
    initParallax(raiz);
    initProducto(raiz);
    initContadores(raiz);
    initEntrega(raiz);
    initPopup(raiz);
    initCaja(raiz);
    moverParallax();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initTodo);
  else initTodo();
  document.addEventListener('shopify:section:load', initTodo);
})();
